import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';

const MachineDropdown = ({ onSelectMachine, value = [], multiSelect = false }) => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const { t } = useTranslation();
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    const fetchMachines = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/all`, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Assuming token is stored in localStorage
          }
        });
        setMachines(response.data);
      } catch (error) {
        console.error(t('MachineDropdown.ErrorFetchingMachines'), error);
      }
    };
    fetchMachines();
  }, [apiBaseUrl, t]);

  const handleSelect = (event) => {
    const selectedMachineId = parseInt(event.target.value);

    if (multiSelect) {
      // Ensure value is always an array for multi-select
      let updatedSelection = Array.isArray(value) ? [...value] : [];

      if (updatedSelection.includes(selectedMachineId)) {
        updatedSelection = updatedSelection.filter(id => id !== selectedMachineId);
      } else {
        updatedSelection.push(selectedMachineId);
      }

      onSelectMachine(updatedSelection);  // Pass updated array of machine IDs
    } else {
      // For single-select, pass the selected machine (object or ID) to the parent component
      const selectedMachine = machines.find(machine => machine.machineid === selectedMachineId);
      onSelectMachine(selectedMachine);
    }
  };

  return (
    <div>
      {multiSelect ? (
        machines.map(machine => (
          <div className="entry-item entry-item__content-width entry-item__checkbox-and-text" key={machine.machineid}>
            <input
              type="checkbox"
              id={machine.machineid}
              value={machine.machineid}
              checked={Array.isArray(value) && value.includes(machine.machineid)}  // Ensure the checkbox is checked if machine ID is in the selected array
              onChange={handleSelect}
            />
            <label htmlFor={machine.machineid}>{machine.machine}</label>
          </div>
        ))
      ) : (
        <select className="form-select" onChange={handleSelect} value={value || ''}>
          <option >{t('MachineDropdown.SelectMachine')}</option>
          {machines.map(machine => (
            <option key={machine.machineid} value={machine.machineid}>
              {machine.machine}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default MachineDropdown;
